import { Injectable } from '@angular/core';

import { CelebrationPromptService } from '#services/celebration-prompt/celebration-prompt.service';
import { CelebrationsService } from '#services/celebrations/celebrations.service';
import { DesignatedContactsService } from '#services/designated-contacts/designated-contacts.service';
import { FamilyMembersService } from '#services/family-members/family-members.service';
import { LyfeVaultService } from '#services/lyfe-vault/lyfe-vault.service';
import { MemoriesService } from '#services/memories/memories.service';
import { MemoryAssetsService } from '#services/memory-assets/memory-assets.service';
import { MemoryInspirationService } from '#services/memory-inspiration/memory-inspiration.service';
import { PurchaseService } from '#services/purchase/purchase.service';
import { SubscriptionService } from '#services/subscription/subscription.service';
import { HomeService } from '#services/home/home.service';

@Injectable({
  providedIn: 'root',
})
export class ResetService {
  constructor(
    private celebrationPromptService: CelebrationPromptService,
    private celebrationsService: CelebrationsService,
    private designatedContactsService: DesignatedContactsService,
    private familyMembersService: FamilyMembersService,
    private lyfeVaultService: LyfeVaultService,
    private memoriesService: MemoriesService,
    private memoryAssetsService: MemoryAssetsService,
    private memoryInspirationsService: MemoryInspirationService,
    private subscriptionService: SubscriptionService,
    private purchaseService: PurchaseService,
    private homeService: HomeService
  ) {}

  resetAllData() {
    this.celebrationPromptService.resetCelebrationPrompts();
    this.celebrationsService.resetCelebrations();
    this.designatedContactsService.resetDesignatedContacts();
    this.familyMembersService.resetFamilyMembers();
    this.lyfeVaultService.resetLyfeVault();
    this.memoriesService.resetMemories();
    this.memoryAssetsService.resetMemoryAssets();
    this.memoryInspirationsService.resetMemoryInspirations();
    this.subscriptionService.resetSubscription();
    this.purchaseService.resetPurchases();
    this.homeService.resetHomeData();
  }
}
